import { CheckCircleSmallIcon } from '@atoms/Icon/CheckCircleSmallIcon';

type Props = {
  userEmail: string;
};
export const CreateStatementSuccess = ({ userEmail }: Props) => {
  return (
    <div className="flex flex-col items-center bg-white">
      <div className="mx-auto mt-0 flex size-12 items-center justify-center rounded-full">
        <CheckCircleSmallIcon />
      </div>
      <p className="text-center text-lg font-medium">
        Your report is being generated
      </p>
      <div className="px-2 py-4 text-center text-sm">
        When the report is ready you will receive an email
        <br />
        <span className="font-bold text-content-brand">{userEmail}</span>
        <br />
        with a link where you can download your report.
      </div>
    </div>
  );
};
